import ReCAPTCHA from "react-google-recaptcha";
import Store from "../redux/Store";
import { setCaptchaCode } from "../redux/Login/LoginActionCreators";
import React from "react";
import { connect } from "react-redux";
const Captcha = ({ resetCaptcha, handler }) => {
  function onChange(value) {
    Store.dispatch(setCaptchaCode(value));
    if (handler) {
      handler();
    }
  }

  const siteKey =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_CAPTCHA_SITE_KEY_DEV
      : process.env.REACT_APP_CAPTCHA_SITE_KEY_DEV;

  return <ReCAPTCHA sitekey={siteKey} onChange={onChange} key={resetCaptcha} />;
};
const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { resetCaptcha } = loginReducer;
  return { resetCaptcha };
};

export default connect(mapStateToProps)(Captcha);
